import React, { useState } from "react";
import * as api from "../../lib/api";

export function PasswordSection() {
  const [current, setCurrent] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (newPw.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (newPw !== confirm) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      await api.changePassword(current, newPw);
      setMessage("Password changed successfully");
      setCurrent("");
      setNewPw("");
      setConfirm("");
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="settings-section" onSubmit={handleSubmit}>
      <p className="settings-eyebrow">Change Password</p>
      <p className="settings-desc">Update your login password</p>

      <div className="form-group">
        <label className="label">Current password</label>
        <input
          className="input"
          type="password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label className="label">New password</label>
        <input
          className="input"
          type="password"
          value={newPw}
          onChange={(e) => setNewPw(e.target.value)}
          minLength={8}
          required
        />
      </div>
      <div className="form-group">
        <label className="label">Confirm new password</label>
        <input
          className="input"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
      </div>

      {error && <p className="error-text">{error}</p>}
      {message && <p className="success-text">{message}</p>}

      <div className="form-actions" style={{ justifyContent: "flex-start" }}>
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Changing..." : "Change Password"}
        </button>
      </div>
    </form>
  );
}
